import * as d3 from 'd3';
import Api from "../Api";
import Thinker from "../components/Thinker";

const HorizontalHistogram = function (options) {
    const container = $(options.container);
    Thinker.begin($(options.container));
    Api.send(options.url, {guideid: container.data('id')}).done(function (values) {
        Thinker.end($(options.container));
        const margin = {
            top: 15,
            right: 25,
            bottom: 30,
            left: 45
        };

        const width = 420 - margin.left - margin.right,
            height = 300 - margin.top - margin.bottom;

        const x = d3.scaleLinear()
            .domain([0, d3.max(values, function (d) {
                return d.perc / 100;
            })])
            .range([0, height]);

        const bins = d3.bin()
            .value(function (d) {
                return d.perc / 100;
            })
            .domain(x.domain())
            .thresholds(x.ticks(10))
            (values);

        const y = d3.scaleLinear()
            .domain([0, d3.max(bins, function (d) {
                return d.length;
            })])
            .range([width, 0]);

        const xAxis = d3.axisLeft()
            .tickFormat(d3.format('.0%'))
            .tickSize(0)
            .scale(x);

        const svg = d3.select(options.svg)
            .attr("width", width + margin.left + margin.right)
            .attr("height", height + margin.top + margin.bottom)
            .append("g")
            .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

        const bar = svg.selectAll(".bar")
            .data(bins)
            .enter().append("g")
            .attr("class", "bar")
            .attr("transform", function (d) {
                return "translate(" + 0 + "," + x(d.x0) + ")";
            });

        bar.append("rect")
            .attr("x", 1)
            .attr('width', 0)
            .attr("height", x(bins[0].x1) - x(bins[0].x0) - 2)
            // animate bars coming out
            .transition()
            .attr("width", function (d) {
                return width - y(d.length);
            })
            .delay(function (d, i) {
                return i * 20;
            })
            .duration(2000);

        bar.append("text")
            .attr("dy", ".75em")
            .attr("y", 6)
            .attr("x", function (d) {
                return width - y(d.length) - 4;
            })
            .attr('text-anchor', 'end')
            .text(function (d) {
                return d.length;
            })
            .style('opacity', 0)
            // transition opacity
            .transition()
            .style('opacity', 1)
            .delay(function (d, i) {
                return i * 20 + 500;
            })
            .duration(2000);

        svg.append("g")
            .attr("class", "x axis")
            .attr("transform", "translate(0, 12)")
            .call(xAxis);
    });
};

export default HorizontalHistogram;
